import React from 'react';

export const CloseFilter = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='3' viewBox='0 0 18 3' fill='none'>
    <path d='M18 0.375001V2.625L0 2.625L9.83491e-08 0.375L18 0.375001Z' fill='black' />
  </svg>
);
